import { useEffect, useState } from 'react';
import { getTier, tierDirection } from '../utils/tier';
import { useI18n } from '../i18n';
import './RatingDeltaToast.css';

interface Props {
  delta: number | null;
  oldRating?: number;
  newRating?: number;
  onDone?: () => void;
}

export function RatingDeltaToast({ delta, oldRating, newRating, onDone }: Props) {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  const [shown, setShown] = useState<{ delta: number; old: number; new: number } | null>(null);

  useEffect(() => {
    if (delta == null || newRating == null || oldRating == null) return;
    setShown({ delta, old: oldRating, new: newRating });
    setVisible(true);
    const hide = setTimeout(() => setVisible(false), 4200);
    const clear = setTimeout(() => { setShown(null); onDone?.(); }, 4700);
    return () => { clearTimeout(hide); clearTimeout(clear); };
  }, [delta, oldRating, newRating]);

  if (!shown) return null;
  const sign = shown.delta > 0 ? '+' : '';
  const cls = shown.delta > 0 ? 'gain' : shown.delta < 0 ? 'loss' : 'neutral';
  const dir = tierDirection(shown.old, shown.new);
  const newTier = getTier(shown.new);
  const rdt = t.ratingDeltaToast as any;
  const promoteLabel = dir === 1 ? rdt.promoted : rdt.demoted;

  return (
    <div className={`rating-delta-toast ${cls} ${visible ? 'visible' : 'hiding'} ${dir !== 0 ? 'tier-changed' : ''}`}>
      <div className="rdt-delta">
        <span className="rdt-arrow">{shown.delta > 0 ? '▲' : shown.delta < 0 ? '▼' : '='}</span>
        <span className="rdt-value">{sign}{shown.delta} ELO</span>
      </div>
      <div className="rdt-progression">
        <span className="rdt-old">{shown.old}</span>
        <span className="rdt-arrow-inline">→</span>
        <span className="rdt-new">{shown.new}</span>
      </div>
      {dir !== 0 && (
        <div className="rdt-tier-banner" style={{ color: newTier.color, borderColor: newTier.color, background: newTier.bgColor }}>
          <span className="rdt-tier-icon">{newTier.icon}</span>
          <span className="rdt-tier-label">{promoteLabel}</span>
          <span className="rdt-tier-name">{(t.tiers as any)[newTier.key]}</span>
        </div>
      )}
    </div>
  );
}

